import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = () => {
  const siteUrl = 'https://tecnoabogado-ia-reset.es';
  const title = 'Tecnoabogado IA | Implementación de Inteligencia Artificial para Despachos de Abogados';
  const description = 'Implementamos IA jurídica segura en tu despacho: entorno estanco RGPD, prompts especializados y estrategia de negocio. Recupera tu tiempo facturable y multiplica tu rentabilidad.';
  const keywords = 'IA para abogados, inteligencia artificial jurídica, legaltech España, automatización despachos, Tecnoabogado, Reset Abogacía, IABOGACIA, prompts legales, IA y RGPD, secreto profesional IA, productividad jurídica, transformación digital despachos';
  
  const schemaOrg = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Tecnoabogado",
    "description": description,
    "url": siteUrl,
    "logo": `${siteUrl}/logo.png`,
    "sameAs": [
      "https://www.linkedin.com/company/tecnoabogado",
      "https://twitter.com/tecnoabogado"
    ],
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "ES"
    },
    "offers": [
      {
        "@type": "Offer",
        "name": "Implementación Tecnojurídica 1 a 1",
        "description": "Consultoría exclusiva de 4 semanas para transformar tu despacho con IA",
        "category": "Consultoría"
      },
      {
        "@type": "Offer",
        "name": "Continuidad Tecnojurídica",
        "description": "Membresía mensual con actualizaciones, comunidad y soporte continuo",
        "price": "97",
        "priceCurrency": "EUR",
        "category": "Membresía"
      }
    ],
    "areaServed": {
      "@type": "Country",
      "name": "España"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "¿Cómo garantizáis la confidencialidad de los datos?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Configuramos entornos estancos donde tus datos y los de tus clientes nunca entrenan modelos externos. Usamos herramientas de grado bancario que garantizan el secreto profesional y cumplimiento total con RGPD."
        }
      },
      {
        "@type": "Question",
        "name": "¿Cuánto tiempo lleva la implementación?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "El proceso de implementación 1 a 1 dura 4 semanas. Incluye diagnóstico inicial, 4 sesiones privadas, configuración completa del ecosistema de IA y soporte prioritario durante el despliegue."
        }
      },
      {
        "@type": "Question",
        "name": "¿Qué diferencia hay entre Implementación y Continuidad?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Implementación es un servicio de consultoría intensiva para configurar tu ecosistema de IA desde cero. Continuidad es una membresía mensual para mantener tu despacho actualizado con nuevas herramientas, contenido exclusivo y comunidad."
        }
      }
    ]
  };

  return (
    <Helmet>
      {/* HTML lang attribute */}
      <html lang="es" />
      
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Tecnoabogado by Reset & IABOGACIA" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Spanish" />
      <meta name="google" content="notranslate" />
      <meta httpEquiv="Content-Language" content="es" />
      <link rel="canonical" href={siteUrl} />

      {/* Open Graph Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${siteUrl}/og-image.jpg`} />
      <meta property="og:locale" content="es_ES" />
      <meta property="og:site_name" content="Tecnoabogado" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={siteUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}/og-image.jpg`} />

      {/* Structured Data (JSON-LD) */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrg)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>

      {/* Additional SEO for AI */}
      <meta name="subject" content="Inteligencia Artificial para Despachos de Abogados" />
      <meta name="topic" content="Tecnología Jurídica, IA Legal, Automatización Legal" />
      <meta name="classification" content="Servicios Profesionales, Consultoría Tecnológica" />
    </Helmet>
  );
};

export default SEO;